export function resolveImageUrl(imageFilename: string) {
  return `//${CDN_ASSETS}/${BUILD_NUMBER}/images/${imageFilename}`;
}
